<div class="pt-[60px] md:pt-[80px] lg:pt-[100px] xl:pt-[150px] relative z-[2]">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px]">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-[25px] items-center">
            <div class="p-[15px] md:p-[20px] lg:py-[30px] lg:px-[20px] rounded-[7px] ltr:xl:mr-[50px] rtl:xl:ml-[50px] bg-white/[.31] dark:bg-black/[.54] border border-white/[.13] dark:border-black/[.13] backdrop-blur-[5.099999904632568px]">
                <img src="images/front-pages/city.png" alt="contact-image" class="rounded-[7px]">
            </div>
            <div>
                <div class="mb-[25px] md:mb-[30px] lg:mb-[35px] xl:mb-[40px] md:max-w-[540px] lg:max-w-full">
                    <h2 class="!mb-0 !text-xl md:!text-2xl lg:!text-[34px] xl:!text-4xl -tracking-[.5px] md:-tracking-[.6px] lg:-tracking-[.8px] xl:-tracking-[1px] !leading-[1.2]">
                        <!--i18n: How Can We Help? We Love to Hear From You. Send Us a Message! -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-contact.h2_01' | translate }}
                    </h2>
                </div>
                @if(_contactService.loading$()) {
                    <ng-container [ngTemplateOutlet]="component_loading"></ng-container>
                }
                @else if(_contactService.isMessageSent$()){
                    <ng-container [ngTemplateOutlet]="component_message_sent"></ng-container>
                }
                @else {
                    <ng-container [ngTemplateOutlet]="component_loaded"></ng-container>
                }
            </div>
        </div>
    </div>
</div>

<ng-template #component_loading>
    <corp-loading></corp-loading>
</ng-template>

<ng-template #component_loaded>
    <form [formGroup]="formContact!">
        <div grid grid-cols-2>
            <div class="mb-[20px] md:mb-[25px]">
                <ng-container *ngTemplateOutlet="tp_name"></ng-container>
            </div>
            <div class="mb-[20px] md:mb-[25px]">
                <ng-container *ngTemplateOutlet="tp_surname"></ng-container>
            </div>
        </div>
        <div class="mb-[20px] md:mb-[25px]">
            <ng-container *ngTemplateOutlet="tp_email"></ng-container>
        </div>
        <div class="mb-[20px] md:mb-[25px]">
            <ng-container *ngTemplateOutlet="tp_phone"></ng-container>
        </div>
        <div class="mb-[20px] md:mb-[25px]">
            <ng-container *ngTemplateOutlet="tp_message"></ng-container>
        </div>

        <button 
            type="submit" 
            class="block w-full lg:text-[15px] xl:text-md py-[12px] px-[17px] bg-primary-500 text-white rounded-md transition-all font-medium hover:bg-primary-500
            disabled:cursor-not-allowed disabled:bg-gray-400 disabled:opacity-60"
            [disabled] = "_contactService.formGroup.invalid"
            (click)="save()">
            <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[29px] rtl:md:pr-[29px]">
                <i class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-xl">
                    autorenew
                </i>
                <!--i18n: Send -->
                {{ 'i18n.app.features.pages.front-pages.common.fp-contact.span_02' | translate }}
            </span>
        </button>

        <!-- TEMPLATE FORM -->
        <ng-template #tp_name>
            <corp-input
                [corp-label]="'i18n.app.features.pages.front-pages.common.fp-contact.label_01' | translate"
                [formControlName]="_contactService.modelNames.name.key">
            </corp-input>
        </ng-template>

        <ng-template #tp_surname>
            <corp-input
                [corp-label]="'i18n.app.features.pages.front-pages.common.fp-contact.label_02' | translate"
                [formControlName]="_contactService.modelNames.surname.key">
            </corp-input>
        </ng-template>

        <ng-template #tp_email>
            <corp-input
                [corp-label]="'i18n.app.features.pages.front-pages.common.fp-contact.label_03' | translate"
                [formControlName]="_contactService.modelNames.email.key">
            </corp-input>
        </ng-template>

        <ng-template #tp_phone>
            <corp-input-phone
                [corp-label]="'i18n.app.features.pages.front-pages.common.fp-contact.label_04' | translate"
                [formControlName]="_contactService.modelNames.phone.key">
            </corp-input-phone>
        </ng-template>

        <ng-template #tp_message>
            <corp-textarea
                [corp-label]="'i18n.app.features.pages.front-pages.common.fp-contact.label_05' | translate"
                [formControlName]="_contactService.modelNames.message.key">
            </corp-textarea>
        </ng-template>
    </form>
</ng-template>

<ng-template #component_message_sent>
    <p class="mx-auto text-gray-600 !leading-[1.6] md:max-w-[650px] lg:max-w-[680px] xl:max-w-[740px] md:text-[15px] lg:text-md xl:text-lg xl:tracking-[.2px]">
        <!-- i18n: Order your currency online securely and pick it up easily at the bpost branch of your choice. Simple, fast and reliable. -->
        {{ 'i18n.app.features.pages.front-pages.common.fp-contact.p_01' | translate }}
    </p>
    <p class="mx-auto text-gray-600 !leading-[1.6] md:max-w-[650px] lg:max-w-[680px] xl:max-w-[740px] md:text-[15px] lg:text-md xl:text-lg xl:tracking-[.2px]">
        <!-- i18n: Order your currency online securely and pick it up easily at the bpost branch of your choice. Simple, fast and reliable. -->
        {{ 'i18n.app.features.pages.front-pages.common.fp-contact.p_02' | translate }}
    </p>
</ng-template>

